(function (angular) {

  angular.module("alk.modal", []);

})(window.angular);

require("./alkModalService");



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-modal/module.js